import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./RegisterPage.css";

const RegisterPage = () => {
  const { register, isAuthenticated, error } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const hasNavigated = useRef(false);

  // Compute form validity for enabling/disabling Register button
  const isFormValid = 
    name.trim().length > 0 &&
    email.trim().length > 0 &&
    password.trim().length > 0 &&
    confirmPassword.trim().length > 0 &&
    password === confirmPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Double-check in case user manipulates DOM
    if (!isFormValid) {
      toast.error("Please complete all fields and ensure passwords match.");
      return;
    }

    setIsSubmitting(true);
    try {
      await register({ name, email, password });
    } catch (error) {
      console.error(
        "Registration failed:",
        error.response?.data?.message || error.message
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated && !hasNavigated.current) {
      navigate("/dashboard");
      toast.success("Registered and logged in successfully!");
      hasNavigated.current = true;
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="register-page">
      <ToastContainer />
       <div className="register-card">
       <Link to="/" className="logo-link">
      <img src="/survailogo.svg" alt="Surv.ai Logo" className="logo-main" />
      </Link>
        <h2>Register</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoComplete="name"
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
              placeholder="Enter your email address"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              placeholder="Create a password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
              placeholder="Re-enter your password"
            />
          </div>

          <button
            type="submit"
            className="register-button"
            disabled={!isFormValid || isSubmitting}
          >
            {isSubmitting ? "Registering..." : "Register"}
          </button>
        </form>

        {/* SSO Buttons */}
        <div className="sso-section">
          <hr />
          <button
  className="sso-button google"
  onClick={() => {
    window.location.href = "/api/auth/google";
  }}
>
  <img src="/google.svg" alt="Google Logo" />
  Sign in with Google
</button>
<button
  className="sso-button microsoft"
  onClick={() => {
    window.location.href = "/api/auth/microsoft";
  }}
>
  <img src="/msft.svg" alt="Microsoft Logo" />
  Sign up with Microsoft
</button>

        </div>
        
        <p className="login-redirect">
          Already have an account? <Link to="/login">Login here.</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
